import { Injectable } from "@angular/core";
import { CrudService } from "app/shared/crud-service";
import { HttpClient } from "@angular/common/http";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { TipoPagamentoDTO } from "../models/tipo-pagamento.model";
import { environment } from "environments/environment";

@Injectable({
    providedIn: "root"
})
export class TiposPagamentoService extends CrudService<TipoPagamentoDTO> implements Resolve<any>{
    
    routeParams: any;

    constructor(protected http: HttpClient) {
        super(http, `${environment.apiUrlRDV}/v1/tipo-pagto-despesa-viagem`);
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;
        if (this.routeParams.id === "new") {
            return new Promise((resolve, reject) => {
                this.onDataChanged.next(false);
                resolve(false);
            });
        } else {
            return this.getById(this.routeParams.id);
        }
    }
    
    updateTipoPagamento (tipoPagamento: TipoPagamentoDTO): Promise<any> {
        
        const id = tipoPagamento.id;

        return new Promise((resolve, reject) => {
            this.http
                .put(`${environment.apiUrlRDV}/tipo-pagto-despesas/${id}`, tipoPagamento)
                .subscribe( res => {
                    resolve(res);
                }, reject);
        })

    }

}